var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// ./~/canvg/~/core-js/internals/well-known-symbol-wrapped.js
// module id = 429
// module chunks = 0